import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { EquipmentHttpService } from '@core/services/http';

export class EquipmentResolver implements Resolver {
  async resolve(): Promise<void> {
    await HttpService.getHttpRequests(EquipmentHttpService).getEquipmentTypes();
  }
}
